export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const TRIVIO_MEETING_URL = process.env.REACT_APP_TRIVIO_MEETING_URL;
export const COMMUNITY_MEETING_URL = process.env.REACT_APP_COMMUNITY_MEETING_URL;